import { render, staticRenderFns } from "./CertificateRequestFormAdd.vue?vue&type=template&id=d54c322e&"
import script from "./CertificateRequestFormAdd.vue?vue&type=script&lang=ts&"
export * from "./CertificateRequestFormAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports